import React, { useEffect, useState } from "react";
import "./styles.scss";
import logo from "../../assets/images/logo-upordown_demo.png";
import tutorial_1 from "../../assets/images/tutorial_1.png";
import tutorial_2 from "../../assets/images/tutorial_2.png";
import tutorial_3 from "../../assets/images/tutorial_3.png";
import tutorial_4 from "../../assets/images/tutorial_4.png";
import tutorial_5 from "../../assets/images/tutorial_5.png";
import tutorial_6 from "../../assets/images/tutorial_6.png";
import tutorial_7 from "../../assets/images/tutorial_7.png";

import { useNavigate } from "react-router-dom";
import useDeviceDetect from "../../hook/useDeviceDetect";

export default function Tutorial() {
  const navigate = useNavigate();
  const [dotSelect, setDotSelect] = useState<number>(0);
  const [isNext, setIsNext] = useState<boolean>(false);
  const { isMobile } = useDeviceDetect();

  const LIST_IMG: any[] = [
    tutorial_1,
    tutorial_2,
    tutorial_3,
    tutorial_4,
    tutorial_5,
    tutorial_6,
    tutorial_7,
  ];

  const LIST_DESCRIPTION: any[] = [
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore",
    "Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet,  ",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore",
    "Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, ",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore",
    "Consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore. Lorem ipsum dolor sit amet, ",
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore",
  ];

  useEffect(() => {
    if (!isMobile) {
      navigate(`/${window.location.search}`);
    }
  }, []);

  useEffect(()=>{
    if(dotSelect===6){
        setIsNext(true);
    }
  },[dotSelect])

  return (
    <div className="wrapper-page-tutorial">
      <div className="wrap-logo">
        <img src={logo} className="logo" alt="" />
      </div>
      <div className="wrapper-content-tutorial">
        <div className="content-tutorial">
          {LIST_IMG.map((item: any, index: number) => {
            return (
              <img
                src={item}
                alt=""
                className={`img-tutorial ${
                  index === dotSelect
                    ? ""
                    : index < dotSelect
                    ? "tutorial_pre"
                    : "tutorial_next"
                }`}
                style={{
                  zIndex:
                    index - dotSelect > 1
                      ? 0
                      : index === dotSelect
                      ? 2
                      : index > dotSelect
                      ? 3
                      : 1,
                }}
                onClick={() => setDotSelect(index)}
              />
            );
          })}
        </div>
      </div>

      <div className="wrapper-description">
        <div className="description">
          <p>
            {LIST_DESCRIPTION[dotSelect]}
          </p>
        </div>
      </div>

      <div className="wrapper-dot">
        {[0, 1, 2, 3, 4, 5, 6].map((item: number) => {
          return (
            <div
              className={`dot ${dotSelect === item && "dot-select"}`}
              key={item}
            />
          );
        })}
      </div>

      <div className=" wrap-start-to-play">
        <div className="container">
          <p className="label-start-to-play" onClick={() => {
            if(!isNext){
                setDotSelect(dotSelect+1);
                return;
            };
            navigate(`/${window.location.search}`);
          }}>
            Start to Play
          </p>
        </div>
      </div>
    </div>
  );
}
